import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ResourcesService {
  constructor(private http: HttpClient) {}

  list(source: 'channel' | 'video', id: string) {
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/2.0/resources/${source}/${id}.json`
    );
  }
}
